import { setRTL } from 'office-ui-fabric-react/lib/Utilities';
import { getOpxHostApi, isOpx } from 'owa-opx';
import { OpxHostApi } from 'owa-opx-host-api';
import { markFunction } from 'owa-performance';
import { hasQueryStringParameter } from 'owa-querystring';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { getCultureOverride } from 'owa-shared-bootstrap/lib/getCultureOverride';
import { getSupportedFallbackForLocale } from 'owa-shared-bootstrap/lib/getSupportedFallbackForLocale';
import { loadInitialTheme } from 'owa-theme';

export default markFunction(async function initializeTheme(userConfig: OwaUserConfiguration) {
    let isRtl = userConfig.SessionSettings.IsUserCultureRightToLeft;
    const cultureOverride = getCultureOverride();
    if (cultureOverride != null) {
        isRtl = getSupportedFallbackForLocale(cultureOverride).dir == 'rtl';
    }
    document.dir = isRtl ? 'rtl' : 'ltr';
    setRTL(isRtl, true); // Ensure ui fabric has up to date RTL
    if (isOpx()) {
        const opxHostApi = await getOpxHostApi();
        opxHostApi.registerThemeChangedHandler(isDarkTheme => {
            internalLoadTheme(isDarkTheme, opxHostApi);
        });

        internalLoadTheme((await opxHostApi.isDarkTheme()) || false, opxHostApi);
    } else {
        await loadInitialTheme(
            userConfig.UserOptions.ThemeStorageId,
            userConfig.UserOptions.IsDarkModeTheme,
            userConfig.SegmentationSettings?.Themes
        );
    }
}, 'ti');

async function internalLoadTheme(isDarkTheme: boolean, opxHostApi: OpxHostApi) {
    loadInitialTheme(
        'base',
        isDarkTheme,
        true,
        hasQueryStringParameter('useOwaTheme')
            ? undefined
            : await opxHostApi.getOpxPalette(isDarkTheme)
    );
}
